import * as React from "react";
import { ASK_CENNA_SELECTION_PROMPT, ASK_CENNA_SUGGESTIONS } from "./constants";
import { IconArrowRight, IconSparkle } from "./icons/ChatIcons";

export type ChatSuggestionChipsProps = {
  onSelect: (text: string) => void;
  hasSelectedText: boolean;
};

export const ChatSuggestionChips: React.FC<ChatSuggestionChipsProps> = ({
  onSelect,
  hasSelectedText,
}) => (
  <div className="chat-suggestion-list">
    <div className="chat-suggestion-list__label">Suggested</div>
    {ASK_CENNA_SUGGESTIONS.map((prompt) => {
      const needsSelection = prompt === ASK_CENNA_SELECTION_PROMPT;
      const disabled = needsSelection && !hasSelectedText;
      return (
        <button
          key={prompt}
          type="button"
          className="cenna-chip"
          disabled={disabled}
          title={disabled ? "Select text in the document first" : undefined}
          onClick={() => {
            if (!disabled) onSelect(prompt);
          }}
        >
          <span className="cenna-chip-spark">
            <IconSparkle size={13} />
          </span>
          <span style={{ flex: "1 1 0%", minWidth: 0 }}>{prompt}</span>
          <span className="cenna-chip-arrow">
            <IconArrowRight size={13} />
          </span>
        </button>
      );
    })}
  </div>
);
